export default "__VITE_ASSET__DRViszXb__"